import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { effectiveBackgroundColor } from 'utils/exportImage';
import { Button, Flex, Space } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFileImage } from '@fortawesome/pro-light-svg-icons';
import { RiskModel } from 'model/RiskModel';
import { RiskCategory } from 'graph/dist/generated';
import * as ExcelJS from 'exceljs';
import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';


const generateImage = (height) => {
    const node = document.querySelector('.Risks .ant-layout-content');

    const calculatedHeight = ((height || node.clientHeight) - 70) * 2 + 30
    domtoimage.toBlob(node, {
        bgcolor: effectiveBackgroundColor(node),
        height: calculatedHeight,
        width: (node.clientWidth - 235) * 2 * 1.2,
        quality: 1,
        filter: (node) => {
            if (!node.className || !node.className.match)
                return true;

            // Avoid classnames containing['ActionButton', 'ant-btn']
            return !node.className.match('ActionsWrapper') && !node.className.match('ant-btn');
        },
        style: {
            transform: "scale(" + 2 + ")",
            marginTop: -150 + "px",
            transformOrigin: `0% 0%`,

            height: calculatedHeight * 1.2,
            width: (node.clientWidth - 235) * 2 * 1.2,
            backgroundColor: "transparent",
            backgroundImage: "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNjYgMTQuMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZGRkZGRjsgZm9udC1mYW1pbHk6J0FyaWFsTVQnLCBzYW5zLXNlcmlmOyBmb250LXNpemU6MTJweDt9Cjwvc3R5bGU+Cjx0ZXh0IGNsYXNzPSJzdDAiPkdlcm9zaXR1c8KuIC0gQWxsIHJpZ2h0cyByZXNlcnZlZDwvdGV4dD4KPC9zdmc+)",
            backgroundRepeat: 'no-repeat',
            backgroundSize: '167.5px 167.5px',
            backgroundPositionX: `16px`,
            backgroundPositionY: `${calculatedHeight / 2 - 15}px`,
        }
    })
        .then(function (blob) {

            // Current date
            saveAs(blob, `Gerositus-${new Date().toLocaleDateString().replace(/\//g, '-') + '-' +
                new Date().toLocaleTimeString().replace(/:/g, '-')
                }.png`);
        });
}

const generateExcel = async (risks: RiskModel[], riskCategories: RiskCategory[]) => {

    const sortedRisks = sortBy(risks, ["reference", "name"]);

    const prepareRow = (risk: RiskModel) => {
        return [
            risk.name,
            risk.reference,
            risk.description,
            risk.impact,
            risk.likelihood,
            (risk.impact || 1) * (risk.likelihood || 1),
            risk.riskCategoryId ? riskCategories.find(c => c.id === risk.riskCategoryId)?.name : '',
        ]
    }

    const columns = [
        { header: 'Name', key: 'name', width: 50 },
        { header: 'Reference', key: 'reference', width: 16 },
        { header: 'Description', key: 'description', width: 80 },
        { header: 'Impact', key: 'impact', width: 18 },
        { header: 'Likelihood', key: 'likelihood', width: 18 },
        { header: 'Exposure', key: 'exposure', width: 18 },
        { header: 'Category', key: 'category', width: 32 },
    ];

    let preparedJson = sortedRisks.filter(r => !r.isOpportunity).map(prepareRow)
    let preparedJsonOpportunities = sortedRisks.filter(r => !!r.isOpportunity).map(prepareRow)



    const workbook = new ExcelJS.Workbook();
    workbook.created = new Date();

    const risksSheet = workbook.addWorksheet('Risks');
    risksSheet.columns = columns;
    risksSheet.addRows(preparedJson);
    risksSheet.autoFilter = {
        from: 'A1',
        to: 'G1',
    }

    const opportunitiesSheet = workbook.addWorksheet('Opportunities');
    opportunitiesSheet.columns = columns;
    opportunitiesSheet.addRows(preparedJsonOpportunities);
    opportunitiesSheet.autoFilter = {
        from: 'A1',
        to: 'G1',
    }

    // Format the header
    risksSheet.getRow(1).eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDDDDD' },
        };
        cell.font = {
            bold: true,
            size: 16
        };
    });

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(new Blob([buffer], { type: "application/octet-stream" }), 'Gerositus-Risks.xlsx');

}

export const ExportTab = ({ height, risks, riskCategories }) => {

    const { t } = useTranslation();

    return (

        <Flex vertical className="mt-05">
            <Button className="mb-1" variant="outlined" onClick={() => generateExcel(risks, riskCategories)}>
                <FontAwesomeIcon icon={faFileExcel} />
                {t('actions.export.excel')}
            </Button>

            <Button onClick={() => { generateImage(height) }}>
                <Space>
                    <FontAwesomeIcon icon={faFileImage} />
                    {t("actions.export.image")}
                </Space>
            </Button>


        </Flex >
    );
}